// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","h1":"h1__yrSRD","nav":"nav__ikPuw"};